module.exports = __webpack_public_path__ + "static/media/esignNavLogoNew.9ad5feaf.svg";